export const ColumnFormattingClasses = {
    categoryGreen: "bg-green-100",
    categoryBlue: "bg-portal-blue-hover", // #cee0ff
    categoryRed: "bg-red-300",
    categoryGrey: "bg-gray-300 bg-opacity-50"
};
